import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Search: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="M9.46242 3.72127C11.017 5.27582 11.017 7.79624 9.46242 9.35078C7.90787 10.9053 5.38745 10.9053 3.8329 9.35078C2.27836 7.79624 2.27836 5.27582 3.8329 3.72127C5.38745 2.16672 7.90787 2.16672 9.46242 3.72127"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.43359 9.37335L13.3336 13.3267"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
